import axios from "axios";
import qs from "qs";
import constants from "../constants";
import authenService from "./authenService";
import deviceInfoService from "./deviceInfoService";
import {EventBus} from "../event-bus.js";
import utils from "./utils";
import {refreshTokenInternal} from "./refreshTokenUtils";
import store from "../store";
// import VueCookies from "vue-cookies";

export default {

  getUploadAttachmentHeaders() {
    let header = {};
    let idToken = authenService.getIdToken();
    idToken && (header["Authorization"] = "Bearer " + idToken);
    // console.log("httpService getUploadAttachmentHeaders " + idToken);
    let userDeptRoleId = store.getters.userDeptRoleId;
    userDeptRoleId &&
    (header[constants.HTTP_HEADER_KEY.USER_DEPT_ROLE_ID] = userDeptRoleId);
    let sessionId = authenService.getSessionId();
    sessionId && (header[constants.HTTP_HEADER_KEY.SESSION_ID] = sessionId);
    return header;
  },

  initConfig(config) {
    !config && (config = {});
    !config.paramsSerializer &&
    (config.paramsSerializer = function (params) {
      return qs.stringify(params, {
        arrayFormat: "repeat"
      });
    });

    !config.baseURL && (config.baseURL = constants.BASE_SERVICE_URL);

    !config.headers && (config.headers = {});

    !config.timeout &&
    (config.timeout = constants.AXIOS_REQUEST_TIMEOUT * 1000);

    let header = config.headers;

    !header["Content-Type"] && (header["Content-Type"] = "application/json");

    let idToken = authenService.getIdToken();
    idToken &&
    (header[constants.HTTP_HEADER_KEY.AUTH_HEADER_STRING] =
      "Bearer " + idToken);
    // console.log("httpService initConfig " + idToken);

    let otpToken = authenService.getOtpToken();
    // console.log(otpToken);
    idToken &&
    (header[constants.HTTP_HEADER_KEY.OTP_AUTH_HEADER_STRING] = otpToken);

    let deviceInfo=deviceInfoService.getDeviceInfo();
    deviceInfo && (header[constants.HTTP_HEADER_KEY.DEVICE_INFO] = deviceInfo);
    let sessionId = authenService.getSessionId();
    sessionId && (header[constants.HTTP_HEADER_KEY.SESSION_ID] = sessionId);

    let roleCode = authenService.get(constants.STORAGE_KEY.ROLE_CODE);
    roleCode && (header[constants.HTTP_HEADER_KEY.ROLE_CODE] = roleCode);

    let deptCode = authenService.get(constants.STORAGE_KEY.DEPT_CODE);
    deptCode && (header[constants.HTTP_HEADER_KEY.DEPT_CODE] = deptCode);

    let userDeptRoleId = store.getters.userDeptRoleId;
    userDeptRoleId &&
    (header[constants.HTTP_HEADER_KEY.USER_DEPT_ROLE_ID] = userDeptRoleId);
    // console.log("httpService initConfig userDeptRoleId " + userDeptRoleId + "  " + header[constants.HTTP_HEADER_KEY.USER_DEPT_ROLE_ID]);

    return config;
  },

  post(url, data, config) {
    config = this.initConfig(config);
    return axios.post(url, data, config).catch(error => {
      this.handleGlobalError(error);
      throw error;
    });
  },

  put(url, data, config) {
    config = this.initConfig(config);
    return axios.put(url, data, config).catch(error => {
      this.handleGlobalError(error);
      throw error;
    });
  },

  get(url, config) {
    // console.log('GET URL', url);
    config = this.initConfig(config);
    return axios.get(url, config).catch(error => {
      this.handleGlobalError(error);
      throw error;
    });
  },

  delete(url, config) {
    config = this.initConfig(config);
    return axios.delete(url, config).catch(error => {
      this.handleGlobalError(error);
      throw error;
    });
  },

  postFile(url, data, config) {
    (!config) && (config = {});
    (!config.responseType) && (config.responseType = "blob");
    return this.post(url, data, config);
  },

  getFlie(url, config) {
    (!config) && (config = {});
    (!config.responseType) && (config.responseType = "blob");
    return this.get(url, config);
  },

  handleGlobalError(error) {
    if (utils.isErrorResponseMatch(error, constants.HTTP_STATUS.UNAUTHORIZED)) {
      const originalRequest = error.config;
      if (error.response.data.error === 'authenticate.jwtExpired' &&
        !originalRequest._retry){
        refreshTokenInternal().then(() => {
          console.log('refresh token OK');
          originalRequest._retry = true;
          let newConfig = this.initConfig(originalRequest);
          let method = originalRequest.method;
          let url = originalRequest.url;
          let data = originalRequest.data;
          if (method === 'get' || method === 'GET') {
            this.get(url, newConfig).then(() => {
              location.reload();
            });
          }else if (method === 'post' || method === 'POST'){
            if (data){
              this.post(url, data, newConfig).then(() => {
                location.reload();
              });
            }else{
              this.post(url, newConfig).then(() => {
                location.reload();
              });
            }
          }else if (method === 'put' || method === 'PUT'){
            this.put(url, newConfig).then(() => {
              location.reload();
            });
          }else if (method === 'put' || method === 'PUT'){
            this.put(url, newConfig).then(() => {
              location.reload();
            });
          }
        });
      // } else if (error.response.data.error === 'authenticate.BlacklistJwtException'){
      //   VueCookies.remove("IdHash");
      //   console.log('BlacklistJwtException');
      //   window.location.href = `${constants.SSO_LOGOUT_CALLBACK}`;
      }else{
        EventBus.$emit(constants.EVENT_BUS.CATCH_ERROR_RESPONSE, {
          error: error
        });
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/services/httpService.js